require('./bootstrap');
import Vue from 'vue';

import tippy from 'tippy.js'

Vue.component('menu-main', require('./components/menu.vue').default);
Vue.component('modal', require('./components/modal.vue').default);
Vue.component('slider', require('./components/slider/slider.vue').default);
Vue.component('slide', require('./components/slider/slide.vue').default);
Vue.component('tooltip', require('./components/tooltip.vue').default);

window.Event = new Vue;

const app = new Vue({
    el: '#app',
    data: {
        mainmenu: false,
        submenu: false,
        media: false,
        showPagination: true,
        lastScrollTop: 0,
        scrollSize: 0
    },
    methods: {
        openModal(name){
            window.Event.$emit('modal.open', name);
        },
        checkWindowSize() {
            let cHeight = document.documentElement.clientHeight;
            let dHeight = document.documentElement.scrollHeight;

            this.scrollSize = dHeight - cHeight;
        },
        setScroll(){
            var st = window.pageYOffset || document.documentElement.scrollTop;

            if(this.scrollSize < 0) {
                // If window is small, always show Pagination
                this.showPagination = true
            } else if(st > 50){
                this.showPagination = true
            } else {
                this.showPagination = true
            }

            this.lastScrollTop = st;
        }
    },
    mounted() {
        this.checkWindowSize();
        this.setScroll();
        window.addEventListener("scroll", () => {
            this.setScroll();
        }, false);
    }
});

